import { normalizeLocale, type AppLocale } from './locales'

const copy = {
  "zh-CN": {
    "earned": "获得经验",
    "shortEarned": "经验",
    "primaryMap": "主要练级地图",
    "endedMap": "结束地点",
    "pointMap": "采样时所在地图",
    "mapHint": "按每条记录的主要练级地图归属整条记录，不是逐地图停留时长拆分。",
    "fallbackMap": "旧记录缺少地图时长，使用开始／结束地图。",
    "partialHint": "仅计已确认片段，缺口未计入，不代表全程收益；效率按有效片段时长计算。",
    "partialRecoveryHint": "经验仅累计已确认片段，缺口未计入；当前时速仅统计恢复后连续区间。",
    "unavailableHint": "有一段经验未能确认，经验暂不可用；当前时速仅统计恢复后区间。",
    "unconfirmedMap": "尚无已确认的地图停留时长，使用开始／结束地点。",
    "formula": "平均 = 获得经验 ÷ 有效记录时长。死亡扣除不抵扣获得经验；零收益时间计入，手动暂停时间排除。"
  },
  "zh-TW": {
    "earned": "獲得經驗",
    "shortEarned": "經驗",
    "primaryMap": "主要練級地圖",
    "endedMap": "結束地點",
    "pointMap": "取樣時所在的地圖",
    "mapHint": "按每筆記錄的主要練級地圖歸屬整筆記錄，不是逐地圖停留時間拆分。",
    "fallbackMap": "舊記錄缺少地圖時間，使用開始／結束地圖。",
    "partialHint": "僅計已確認片段，缺口未計入，不代表全程收益；效率按有效片段時間計算。",
    "partialRecoveryHint": "經驗僅累計已確認片段，缺口未計入；目前時速僅統計恢復後連續區間。",
    "unavailableHint": "有一段經驗未能確認，經驗暫不可用；目前時速僅統計恢復後區間。",
    "unconfirmedMap": "尚無已確認的地圖停留時間，使用開始／結束地點。",
    "formula": "平均 = 獲得經驗 ÷ 有效記錄時間。死亡扣除不抵扣獲得經驗；零收益時間計入，手動暫停時間排除。"
  },
  "en": {
    "earned": "EXP gained",
    "shortEarned": "EXP",
    "primaryMap": "Main training map",
    "endedMap": "Ending location",
    "pointMap": "Map at sample time",
    "mapHint": "Each entire record belongs to its main training map; these totals do not split time between maps.",
    "fallbackMap": "Map durations are missing; using the starting or ending map.",
    "partialHint": "Only confirmed segments count; gaps are excluded. This is not a full-session total. Rates use confirmed segment duration.",
    "partialRecoveryHint": "EXP includes only confirmed segments; gaps are excluded. The rate covers only the uninterrupted segment after recovery.",
    "unavailableHint": "Some EXP readings could not be confirmed, so session EXP is unavailable. The rate covers only the uninterrupted segment after recovery.",
    "unconfirmedMap": "No confirmed map duration yet; using the starting or ending location.",
    "formula": "Average = EXP gained / active recording time. Death losses do not reduce earnings. Zero-gain time counts; manual pauses do not."
  },
  "ja": {
    "earned": "獲得経験値",
    "shortEarned": "経験値",
    "primaryMap": "主な狩場",
    "endedMap": "終了地点",
    "pointMap": "サンプル時のマップ",
    "mapHint": "各記録全体を主な狩場に分類します。マップ別の滞在時間への分割ではありません。",
    "fallbackMap": "マップ滞在時間がないため、開始／終了マップを使用します。",
    "partialHint": "確認済み区間のみを集計し、欠損区間は含みません。記録全体の合計ではなく、効率は有効区間の時間で算出します。",
    "partialRecoveryHint": "確認済み区間の経験値のみを集計し、欠損区間は含みません。現在の効率は復旧後の連続区間のみで算出します。",
    "unavailableHint": "未確認の経験値があるため合計を表示できません。現在の効率は復旧後の連続区間のみで算出します。",
    "unconfirmedMap": "確認済みのマップ滞在時間がないため、開始／終了地点を使用します。",
    "formula": "平均 = 獲得経験値 ÷ 有効記録時間。死亡による損失は差し引きません。獲得ゼロの時間は含み、手動の一時停止は除きます。"
  },
  "ko": {
    "earned": "획득 경험치",
    "shortEarned": "경험치",
    "primaryMap": "주요 사냥터",
    "endedMap": "종료 위치",
    "pointMap": "샘플 시점의 지도",
    "mapHint": "각 기록 전체를 주요 사냥터에 배정합니다. 지도별 체류 시간으로 나눈 통계가 아닙니다.",
    "fallbackMap": "지도별 시간이 없어 시작 또는 종료 지도를 사용합니다.",
    "partialHint": "확인된 구간만 집계하며 누락 구간은 제외합니다. 전체 기록 합계가 아니며 효율은 유효 구간 시간으로 계산합니다.",
    "partialRecoveryHint": "확인된 구간의 경험치만 집계하며 누락 구간은 제외합니다. 현재 효율은 복구 후 연속 구간만 반영합니다.",
    "unavailableHint": "확인하지 못한 경험치가 있어 합계를 표시할 수 없습니다. 현재 효율은 복구 후 구간만 반영합니다.",
    "unconfirmedMap": "확인된 지도별 체류 시간이 없어 시작 또는 종료 위치를 사용합니다.",
    "formula": "평균 = 획득 경험치 ÷ 유효 기록 시간. 사망 손실은 차감하지 않습니다. 획득이 없는 시간은 포함하고 수동 일시 정지는 제외합니다."
  }
} satisfies Record<AppLocale, Record<string, string>>

export function expAccountingText(locale: string, key: keyof typeof copy.en): string {
  return copy[normalizeLocale(locale)][key]
}

export function expGainedLabel(locale: string, short = false): string {
  return expAccountingText(locale, short ? 'shortEarned' : 'earned')
}
